import { Action } from "csi/def/Action";
import { attributeIsInlineEditable } from "csi/service/viewService";
import { Context } from "csi/def/Context";
import { C8Node } from "csi/typings";
import declare from "dojo/_base/declare";
import locale from "csi/locale";
import xml from "csi/xml";

const RES: string = "ActionAttribute";

const AttributeActionMixin = declare(null, {
	/**
	 * @override
	 * Simple attribute actions (i.e. inline edits and some others) should not disable the view
	 * as it delays the popup editor from appearing
	 * @type {boolean}
	 * */
	bKeepViewEnabled: true,

	/**
	 * @override
	 * Do not allow attribute being editing to be restarted by clicking on the cell (outside editor)
	 * @type {boolean}
	 * */
	testForRepetition: true,

	/**
	 * Heading on which action will act
	 * @type {Heading}
	 */
	heading: null,

	/**
	 * Default tag for action
	 * @type {string}
	 */
	m_tag: RES,

	/**
	 * @override
	 * aggregateId comes from parent Heading
	 */
	resolve(): void {
		this.inherited(arguments);
		const action = this as unknown as Action;
		if (action.m_name == action.m_tag) {
			action.m_name = locale.resourceIfExists(action.m_id) || locale.resource(RES);
		}
	},

	/**
	 * @override
	 * Check if attribute is inline editable according to the model, whether or not the action requires any access rights
	 * to edit it.
	 */
	hasAccess(ctx: Context): boolean {
		const [isEditable, isFormOnly] = attributeIsInlineEditable(ctx.getNode(), this.heading.m_id, this.heading.m_path);
		return isEditable && this.inherited<boolean>(arguments);
	},

	/**
	 * Allow attribute to be editable even when the node is Frozen, so override default node flags with just read-only check
	 */
	_checkAttributeAccess(node: C8Node, id: string, path: string): boolean {
		const action = this as unknown as Action;
		const nodeFlags = action.editableOnFrozenNode ? [xml.NODE_FLAG_NOEDIT] : null;
		return xml.nodeHasRight(node, action.m_rightBase) && xml.nodeHasAccess(node, action.m_right, id, nodeFlags, [xml.ATTR_FLAG_NOEDIT]);
	},
});

export = AttributeActionMixin;